"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentFromChunkById = void 0;
const getComponentFromChunkById = (chunk, componentId) => {
    return chunk === null || chunk === void 0 ? void 0 : chunk.find((cmp) => cmp.id === componentId);
};
exports.getComponentFromChunkById = getComponentFromChunkById;
//# sourceMappingURL=get-component-from-chunk-by-id.js.map